// Min/max peaks for fast waveform drawing at any zoom level.
const BLOCK = 256;

export class Peaks {
  readonly channels: Float32Array[];
  /** Per channel: interleaved [min, max] for each block of BLOCK samples. */
  private readonly mip: Float32Array[];
  constructor(readonly buffer: AudioBuffer) {
    this.channels = [];
    for (let c = 0; c < buffer.numberOfChannels; c++) this.channels.push(buffer.getChannelData(c));
    this.mip = this.channels.map((d) => {
      const n = Math.ceil(d.length / BLOCK);
      const out = new Float32Array(n * 2);
      for (let b = 0; b < n; b++) {
        let lo = 1, hi = -1;
        const end = Math.min(d.length, (b + 1) * BLOCK);
        for (let i = b * BLOCK; i < end; i++) {
          const v = d[i];
          if (v < lo) lo = v;
          if (v > hi) hi = v;
        }
        out[b * 2] = lo;
        out[b * 2 + 1] = hi;
      }
      return out;
    });
  }
  get sampleRate() {
    return this.buffer.sampleRate;
  }
  /** Min/max of channel `c` over sample range [s0, s1). */
  range(c: number, s0: number, s1: number): [number, number] {
    const d = this.channels[c];
    s0 = Math.max(0, Math.floor(s0));
    s1 = Math.min(d.length, Math.ceil(s1));
    if (s1 <= s0) {
      const v = d[Math.min(d.length - 1, s0)] ?? 0;
      return [v, v];
    }
    let lo = 1, hi = -1;
    if (s1 - s0 > BLOCK * 4) {
      const m = this.mip[c];
      const b0 = Math.ceil(s0 / BLOCK), b1 = Math.floor(s1 / BLOCK);
      for (let i = s0; i < b0 * BLOCK; i++) { const v = d[i]; if (v < lo) lo = v; if (v > hi) hi = v; }
      for (let b = b0; b < b1; b++) { if (m[b * 2] < lo) lo = m[b * 2]; if (m[b * 2 + 1] > hi) hi = m[b * 2 + 1]; }
      for (let i = b1 * BLOCK; i < s1; i++) { const v = d[i]; if (v < lo) lo = v; if (v > hi) hi = v; }
    } else {
      for (let i = s0; i < s1; i++) { const v = d[i]; if (v < lo) lo = v; if (v > hi) hi = v; }
    }
    return [lo, hi];
  }
}
